var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_has.js
// module id = 8
// module chunks = 0